import React from 'react'
import "./sectionDataSources.scss"

//Imagens:
import ImgSectionDataSources from "../../../../assets/dataSources/sectionDataSources.png"
import { useTranslation } from 'react-i18next'

function SectionDataSources() {

  const { t } = useTranslation()

  return (
    <div className='container-section-data-sources'>
      <div className="img-section-data-sources">
        <img src={ImgSectionDataSources} alt="imagem data sources" />
      </div>
      <div className="texts-section-data-sources">
        <h1>{t("datasources.title")}</h1>
        <p>{t("datasources.section_text")}</p>
        <a href="/form" style={{ textDecoration: "none" }}><button id="btn-section-data-sources">{t("buttons.demo_btn_alternative_text_1")}</button></a>
      </div>
    </div>
  )
}

export default SectionDataSources